import {Table, TableCell, TableHead, TableRow} from '@luminopia/react-toolbox/lib/table'
import {DosageDataPoint} from 'core/prescription'
import {pluralize} from 'core/utils/number-helpers'
import {msToMinutes} from 'core/utils/time-helpers'
import * as React from 'react'
import * as styles from './dosage-table.css'

export interface IProps {
  data: DosageDataPoint[]
  /** The total prescribed dosage, in milliseconds */
  totalDosage: number
  /** The total prescribed dosage, in milliseconds */
  totalCompletedDosage: number
}

export class DosageTable extends React.Component<IProps, {}> {
  public render() {
    const dosages = this.props.data
    const totalCompletedDosage = this.props.totalCompletedDosage
    const totalDosage = this.props.totalDosage

    return (
      <Table selectable={false}>
        <TableHead>
          <TableCell>date</TableCell>
          <TableCell>completed dosage</TableCell>
          <TableCell>prescribed dosage</TableCell>
        </TableHead>

        <TableRow>
          <TableCell className={styles.totalCell}>
            TOTAL
          </TableCell>
          <TableCell className={styles.totalCell}>
            {pluralize(msToMinutes(totalCompletedDosage), 'minute')}
          </TableCell>
          <TableCell className={styles.totalCell}>
            {pluralize(msToMinutes(totalDosage), 'minute')}
          </TableCell>
        </TableRow>

        {dosages.map((dosage) => (
          <TableRow key={dosage.date}>
            <TableCell>{dosage.date}</TableCell>
            <TableCell>{pluralize(msToMinutes(dosage.completed), 'minute')}</TableCell>
            <TableCell>{pluralize(msToMinutes(dosage.prescribed), 'minute')}</TableCell>
          </TableRow>
        ))}
      </Table>
    )
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/components/prescription/dosage-table.tsx